import { IScoSystem } from 'src/app/models/scosystem.interface';

export interface IScoSystemState {
    scosystem: IScoSystem;
}

export const initialScoSystemState: IScoSystemState = {
    scosystem: null
};
